import React from 'react'
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'
import { toast } from 'react-toastify'

import { IconFacebook, IconShareLink, IconTwitter, IconWhatsapp } from '../../../../Ui/Icons'

type Props = {
  shareUrl: string
}

export function InfoWindowSharedSection(props: Props) {
  const { shareUrl } = props

  return (
    <div className="share-buttons">
      <span>Share:</span>
      <div className="share-buttons-container">
        <FacebookShareButton url={shareUrl} className="share-button">
          <IconFacebook />
        </FacebookShareButton>
        <TwitterShareButton
          url={shareUrl}
          title={'Hey! This is interesting: '}
          className="share-button"
        >
          <IconTwitter />
        </TwitterShareButton>
        <WhatsappShareButton
          url={shareUrl}
          title={'Hey! This is interesting: '}
          className="share-button"
        >
          <IconWhatsapp />
        </WhatsappShareButton>
        <button
          className="share-button share-button-copy-link"
          onClick={() => {
            navigator.clipboard.writeText(shareUrl)
            toast.success('Link copied')
          }}
        >
          <IconShareLink />
        </button>
      </div>
    </div>
  )
}
